import { Api } from '../../services/http/Api';
import { throwIfGenericApiError } from '../GenericErrors';

export type ProductFlowLink = {
  product_sap_code: string;
  basket_flow_id: number;
  product: { id: number; sap_code: string; description: string } | null;
  flow: { id: number; code: string; active: boolean } | null;
};

class ProductFlowsDatasource {
  protected path = 'basket/product-flow';

  async getAll(): Promise<ProductFlowLink[]> {
    const response = await new Api().fetch(this.path);
    throwIfGenericApiError(response);
    if (!Array.isArray(response)) {
      throw new Error('A resposta da consulta de vínculos está inválida.');
    }
    return response as ProductFlowLink[];
  }

  async link(flowId: number, sapCodes: string[]): Promise<ProductFlowLink[]> {
    const response = await new Api().post(this.path, {
      flow_id: flowId,
      sap_codes: sapCodes,
    });
    throwIfGenericApiError(response);
    return response as ProductFlowLink[];
  }

  async unlink(sapCode: string): Promise<void> {
    const response = await new Api().delete(
      `${this.path}/${encodeURIComponent(sapCode)}`
    );
    throwIfGenericApiError(response);
  }
}

export const ProductFlowsDataSource = new ProductFlowsDatasource();
